/**
 * Base class for integration requests used in the Integration Bus.
 * Integration requests are synchronous, blocking operations, where the caller waits for a response.
 */
abstract class IntegrationRequest<TPayload = void, TResponse = void> {
    /**
     * Unique key identifying the request type.
     * Defined in BusObjectFactory.createRequest.
     */
    public static readonly requestKey: string;

    /** Type discriminator to differentiate between events and requests. */
    public readonly integrationBusObjectType = "request" as const;

    /** Type-only property to capture the response type */
    public readonly responseType?: TResponse = undefined as never;

    /** The payload of the request */
    public readonly payload?: TPayload;

    /**
     * Constructor to initialize the request with an optional payload.
     * @param payload The payload of the request.
     */
    constructor(payload: TPayload) {
        this.payload = payload;
    }
}

export { IntegrationRequest };
